// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.
export const UNSUBSCRIBE_ALL = 'unsubscribeAll';
export const VALIDATE = 'validate';
export const UNSUBSCRIBE_SINGLE = 'unsubscribeSingle';

export const TOPIC_KEY = 'mycars-user-update';
export const MY_CARS_KEY = 'mycars-user';

export const mockLabels = {
	MYCARS_GENERAL_ERROR: "We've encountered an error. Please try again later.",
	MYCARS_INVALID_REQUEST_ERROR:
		'This is an invalid request, please click the link from your Price Alert email to try again.',
	ERROR: 'Error',
	MYCARS_ALERT_SIGN_UP: "You're signed up!",
	MYCARS_WE_EMAIL_YOU:
		"We'll email you with any price changes on this vehicle.",
	MYCARS_ALSO_TRACKING: "You're also tracking the price on",
	MORE_VEHICLES: 'more vehicles',
	OTHER_VEHICLE: 'other vehicle',
	MYCARS_STOP_TRACKING_ALL_PRICE: "You've stopped tracking all prices",
	MYCARS_STOP_TRACKING_PRICE: "You've stopped tracking this price",
	MYCARS_NO_LONGER_EMAIL_YOU_ALL:
		"We'll no longer email you with any price changes",
	MYCARS_NO_LONGER_EMAIL_YOU:
		"We'll no longer email you with any price changes on this vehicle"
};
